export function normalizePagePath(path: string): string {
  if (!path) {
    return '/'
  }
  return path.length > 1 && path.endsWith('/') ? path.slice(0, -1) : path
}

export function isNextPage(path: string, nextPages: string[]): boolean {
  const normalized = normalizePagePath(path)
  return nextPages.some((page) => normalizePagePath(page) === normalized)
}
